import { formatMoney } from '../../../helpers/utils'

export const buildMetricsSummaryCards = (config, data) => {
  if (!data) return []

  const { metrics = {}, totals = {} } = data

  return config.map(card => {
    const rawValue = metrics[card.key]

    let value = '—'

    if (rawValue !== null && rawValue !== undefined) {
      if (card.format === 'money') {
        value = formatMoney(rawValue)
      } else {
        value = Math.trunc(rawValue)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      }
    }

    const chip =
      card.fillRateKey && totals[card.fillRateKey] !== undefined
        ? `Fill rate: ${totals[card.fillRateKey].toFixed(2)}%`
        : null

    return {
      ...card,
      value,
      chip
    }
  })
}
